import * as R from 'ramda';
import { createSelector } from 'reselect';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
//////////////////////////////////////////////////

const store = (state) => state.carrierPortal;

const makeSelectPortal = () => createSelector(
  store,
  ({ portal }) => portal,
);

const makeSelectDeclineReason = () => createSelector(
  store,
  ({ declineReasons }) => declineReasons,
);

const makeSelectCarrierName = () => createSelector(
  store,
  ({ carrierResponseDetailPage }) => R.path(['carrierName'], carrierResponseDetailPage),
);

const makeSelectCarrierChat = () => createSelector(
  store,
  ({ carrierResponseDetailPage }) => R.pathOr([], ['chatData'], carrierResponseDetailPage),
);

const makeSelectCarrierPortalInfo = () => createSelector(
  store,
  ({ carrierResponseDetailPage }) => R.or(carrierResponseDetailPage, []),
);

const makeSelectMobView = () => createSelector(
  store,
  ({ carrierResponseDetailPage }) => R.path(['mobView'], carrierResponseDetailPage),
);

const makeSelectCarrierDocsOutsideApp = () => createSelector(
  store,
  ({ carrierResponseDetailPage }) => R.path(['documents'], carrierResponseDetailPage),
);

const makeSelectMessage = () => createSelector(
  store,
  ({ portal }) => R.path(['messageStatus'], portal),
);

const makeSelectStatusReason = () => createSelector(
  store,
  ({ portal }) => R.path(['status'], portal),
);

const makeSelectPreviousPathName = () => createSelector(
  store,
  ({ portal }) => R.path(['previousPathName'], portal),
);

const makeSelectStatusReasonCodes = () => createSelector(
  store,
  ({ carrierResponseDetailPage }) => R.path(['statusReasonCodes'], carrierResponseDetailPage),
);

const makeSelectTelMappedEventsForMap = () => createSelector(
  store,
  (carrierPortal) => {
    const stops = R.map((stop) => {
      const lat = R.path([GC.SYSTEM_OBJECT_LOCATION, GC.FIELD_LATITUDE], stop);
      const lng = R.path([GC.SYSTEM_OBJECT_LOCATION, GC.FIELD_LONGITUDE], stop);
      if (R.or(R.isNil(lat), R.isNil(lng))) return null;
      return {
        ...stop,
        latLng: { lat, lng },
        title: `${G.toTitleCase(stop.eventType)} ${G.ifElse(
          G.isNotNilAndNotEmpty(stop.cloEventIndex),
          stop[GC.FIELD_CLO_EVENT_INDEX],
          stop[GC.FIELD_TEL_EVENT_INDEX],
        )}`,
      };
    }, R.pathOr([], ['carrierResponseDetailPage', GC.FIELD_LOAD_STOPS], carrierPortal));

    return R.compose(
      R.sortBy(R.prop(GC.FIELD_TEL_EVENT_INDEX)),
      R.values(),
      R.filter((event) => G.isNotNil(event)),
    )(stops);
  },
);

const makeSelectAcceptedDispatch = () => createSelector(
  store,
  ({ acceptedDispatch }) => acceptedDispatch,
);

const makeSelectDeclinedDispatch = () => createSelector(
  store,
  ({ declinedDispatch }) => declinedDispatch,
);

const makeSelectCarrierToken = () => createSelector(
  store,
  R.path(['portal', 'token']),
);

const makeSelectEvents = () => createSelector(
  store,
  R.path(['carrierResponseDetailPage', 'events']),
);

const makeSelectBranchGuid = () => createSelector(
  store,
  R.path(['carrierResponseDetailPage', GC.FIELD_BRANCH_GUID]),
);

const makeSelectPortalType = () => createSelector(
  store,
  ({ portalType }) => portalType,
);

const makeSelectCloRefTypes = () => createSelector(
  store,
  ({ cloRefTypes }) => cloRefTypes,
);

export {
  makeSelectPortal,
  makeSelectEvents,
  makeSelectMessage,
  makeSelectMobView,
  makeSelectBranchGuid,
  makeSelectPortalType,
  makeSelectCarrierChat,
  makeSelectCarrierName,
  makeSelectCloRefTypes,
  makeSelectCarrierToken,
  makeSelectStatusReason,
  makeSelectDeclineReason,
  makeSelectAcceptedDispatch,
  makeSelectDeclinedDispatch,
  makeSelectPreviousPathName,
  makeSelectStatusReasonCodes,
  makeSelectCarrierPortalInfo,
  makeSelectCarrierDocsOutsideApp,
  makeSelectTelMappedEventsForMap,
};
